/* ============================================================
   Pholoh cart rewards bar — TEES "Buy 2, get 1 free". Counts the T-shirts in the
   cart: 1 shirt = halfway, 2 shirts = free shirt unlocked. Recomputes on every
   cart change (ajaxProduct:added + [data-subtotal] mutation) via /cart.js. Also
   mirrors the live total onto the checkout button + drawer title count.
   ============================================================ */
(function () {
  'use strict';

  // A cart line is a "shirt" if its handle/type/title says so (tees are '*-t-shirt').
  function isShirt(it) {
    var h = (it.handle || '').toLowerCase();
    var t = (it.product_type || '').toLowerCase();
    var ti = (it.product_title || it.title || '').toLowerCase();
    return h.indexOf('t-shirt') > -1 || t.indexOf('shirt') > -1 || t.indexOf('tee') > -1 || ti.indexOf('t-shirt') > -1;
  }
  function countShirts(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (isShirt(it)) n += (it.quantity || 0); });
    return n;
  }

  function render(bar, shirts) {
    // Repeating "buy 2, get 1 free": progress cycles every 2 tees, then resets.
    var cyclePos = shirts % 2;
    var freeCount = Math.floor(shirts / 2);
    var seg1 = 0, seg2 = 0, completeNow = false;
    if (shirts > 0 && cyclePos === 0) { seg1 = 100; seg2 = 100; completeNow = true; }
    else if (cyclePos === 1) { seg1 = 100; }
    var fills = bar.querySelectorAll('.rewards__seg-fill');
    if (fills[0]) fills[0].style.width = seg1 + '%';
    if (fills[1]) fills[1].style.width = seg2 + '%';
    var tiers = bar.querySelectorAll('.rewards__tier');
    if (tiers[0]) tiers[0].classList.toggle('is-done', seg1 >= 100);
    if (tiers[1]) tiers[1].classList.toggle('is-done', seg2 >= 100);
    var msg = bar.querySelector('[data-gwp-msg]');
    if (msg) {
      if (shirts <= 0) msg.innerHTML = 'Add 2 tees, get 1 <strong>free</strong>';
      else if (cyclePos === 1) msg.innerHTML = 'Add <strong>1 more tee</strong> — get 1 free';
      else {
        var earned = freeCount === 1 ? 'Free tee unlocked!' : freeCount + ' free tees unlocked!';
        msg.innerHTML = earned + ' Add <strong>2 more</strong> for another';
      }
    }
    bar.classList.toggle('rewards--complete', completeNow);
  }

  function renderAll(shirts) {
    document.querySelectorAll('[data-pholoh-gwp]').forEach(function (b) { render(b, shirts); });
  }

  function syncCheckoutTotal() {
    var ct = document.querySelector('[data-pholoh-checkout-total]');
    var sub = document.querySelector('[data-subtotal]');
    if (!ct || !sub) return;
    /* Write into the inner "now" span, NOT the whole button total: the total also holds the
       struck original price, and replacing innerHTML wholesale would delete it. */
    var now = ct.querySelector('[data-total-now]');
    if (now) now.innerHTML = sub.innerHTML;
    else ct.innerHTML = sub.innerHTML;
  }

  /* Struck-through original next to the discounted total. cart.js gives both numbers, and
     original_total_price only differs once a spend tier has actually unlocked — so the
     strike stays hidden rather than printing the same figure twice. */
  /* The compare-at total the cart markup carries, or null when it is not there.
     /cart.js has NO compare_at_price on line items, so this number cannot be derived in
     JS — templates/cart.ajax.liquid works it out and cartMarkup() drops it into the DOM
     with the rest of the products. Read it from there. */
  function compareTotalFromDOM() {
    var el = document.querySelector('[data-cart-compare-total]');
    if (!el) return null;
    var v = parseInt(el.getAttribute('data-cart-compare-total'), 10);
    return isNaN(v) ? null : v;
  }

  function syncWasTotal(cart) {
    if (!cart) return;
    var fmt = (window.theme && theme.Currency && theme.Currency.formatMoney)
      ? function (c) { return theme.Currency.formatMoney(c, theme.settings.moneyFormat); }
      : function (c) { return '$' + (c / 100).toFixed(2); };
    if (window.PholohMoney) { fmt = function (c) { return window.PholohMoney.format(c); }; }
    /* Take whichever "was" is larger: a spend-tier discount (original_total_price) or the
       sum of compare-at prices. They are different things and either can be the real one —
       and on a flat sale it is always the compare-at, which is why the strike used to stay
       hidden through the whole sale. */
    var was = cart.original_total_price;
    var cmp = compareTotalFromDOM();
    if (cmp !== null && cmp > was) was = cmp;
    /* Diego 10-07: once free shipping is unlocked, the $12 label is part of what they save (same rule as the rail) */
    var basis = (cart.items_subtotal_price != null) ? cart.items_subtotal_price : cart.total_price;
    if (basis >= 15000 && !(cart.discount_codes || []).some(function (c) { return c.applicable; })) was += 1200;
    var discounted = was > cart.total_price;
    document.querySelectorAll('[data-total-was]').forEach(function (el) {
      el.innerHTML = fmt(was);
      el.hidden = !discounted;
    });
  }
  function syncCount(count) {
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = '(' + count + ')'; });
  }

  function refresh() {
    syncCheckoutTotal();
    var hasBar = document.querySelector('[data-pholoh-gwp]');
    var hasCount = document.querySelector('[data-cart-count]');
    var hasWas = document.querySelector('[data-total-was]');
    if (!hasBar && !hasCount && !hasWas) return;
    /* cache:'no-store' — /cart.js is served from cache otherwise and the totals come back
       one change stale, which shows the wrong saving straight after add/remove. */
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderAll(countShirts(cart));
        syncCount(cart.item_count);
        syncWasTotal(cart);
      })
      .catch(function () {});
  }

  function init() {
    var bars = document.querySelectorAll('[data-pholoh-gwp]');
    bars.forEach(function (b) { render(b, parseInt(b.dataset.shirts || '0', 10)); }); // initial (Liquid count)
    syncCheckoutTotal();
    if (!bars.length && !document.querySelector('[data-pholoh-checkout-total]') && !document.querySelector('[data-cart-count]') && !document.querySelector('[data-total-was]')) return;
    document.addEventListener('ajaxProduct:added', refresh);
    var sub = document.querySelector('[data-subtotal]');
    if (sub) new MutationObserver(refresh).observe(sub, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
